<template>
    <div ref="rangeSelector">
        <UPopover :ui="{content: 'z-1'}">
            <UButton
                ref="presetToggler"
                data-cy="date-range-selector"
                color="neutral"
                variant="outline"
                icon="i-ph-calendar"
            >
                {{ chosenPeriod }}
            </UButton>
            <template #content>
                <range-preset-selector
                    ref="rangePresets"
                    v-model="range"
                />
            </template>
        </UPopover>
    </div>
</template>

<script setup lang="ts">
import {computed, ref, watch} from 'vue'
import {DateRange} from './DateRange'
import useDateRange from './useDateRange'
import RangePresetSelector from '@/dateUtils/RangePresetSelector.vue'
import {updatePersistedRange} from '@/dateUtils/dateRange.service'
import {isBefore, formatDate, format} from 'date-fns'

const props = defineProps({
    modelValue: {
        type: Object as () => DateRange,
        required: true
    },
    showStartDatePicker: {
        type: Boolean,
        default: true
    }
})

const {
    range,
    startDate, endDate
} = useDateRange(props.modelValue?.start, props.modelValue?.end)

const rangeSelector = ref<HTMLElement | null>(null)
const presetToggler = ref(null)
const rangePresets = ref(null)

const showStartDateToolTip = ref(false)
const showEndDateToolTip = ref(false)

const datepickerIsError = computed(() => {
    if (!props.showStartDatePicker) return false
    return startDate > endDate
})


const chosenPeriod = computed(() => {
    if (range.value.start && range.value.end) {
        //return chosen period as date range
        return `${formatDate(range.value.start, 'dd.MM.yy')} - ${formatDate(range.value.end, 'dd.MM.yy')}`
    }
    return ''
})

const emit = defineEmits(['update:modelValue'])

const emitUpdate = () => {
    updatePersistedRange(range.value)
    emit('update:modelValue', range.value)
}

watch(range, () => {
    emitUpdate()

    if (datepickerIsError.value && !isBefore(endDate.value, startDate.value)) {
        showStartDateToolTip.value = false
        showEndDateToolTip.value = false
    }
})

watch(() => props.modelValue, (incoming) => {
    if (!incoming) return
    if (format(incoming.start, 'yyyy-MM-dd') !== format(range.value.start, 'yyyy-MM-dd') ||
        format(incoming.end, 'yyyy-MM-dd') !== format(range.value.end, 'yyyy-MM-dd')) {
        range.value = incoming
    }
}, {deep: true})

</script>

<style scoped>

</style>